import * as types from '@/store/mutation-types';
import _ from 'lodash';

const state = {
  shareableList: [],
  shareables: {},
  s3DeleteQueue: [],
  globalToolBarOpen: false,
  globalBubbleOpen: false,
  globalDragEl: false,
  globalBubbleOptionsOpen: false,
  globalBounceDroplet: false,
  globalOpenModal: false,
  dragging: false,
  vnodeDragId: null,
  revertedDroplet: {},
  droppedId: null,
};

const getters = {
  shareables(state) {
    return state.shareables;
  },
  shareableList(state) {
    return state.shareableList;
  },
  getSharedDroplets(state) {
    return type => state.shareables[type] || {};
  },
  s3DeleteQueue(state) {
    return state.s3DeleteQueue;
  },
  globalToolBarOpen(state) {
    return state.globalToolBarOpen;
  },
  globalBubbleOpen(state) {
    return state.globalBubbleOpen;
  },
  globalDragEl(state) {
    return state.globalDragEl;
  },
  globalBubbleOptionsOpen(state) {
    return state.globalBubbleOptionsOpen;
  },
  globalOpenModal(state) {
    return state.globalOpenModal;
  },
  dragging(state) {
    return state.dragging;
  },
  vnodeDragId(state) {
    return state.vnodeDragId;
  },
  globalBounceDroplet(state) {
    return state.globalBounceDroplet;
  },
  revertedDroplet(state) {
    return state.revertedDroplet;
  },
  droppedId(state) {
    return state.droppedId;
  },
};

const mutations = {
  [types.BOUNCE_DROPLET](state, p) {
    state.globalBounceDroplet = p.value;
    this._vm.$set(p.drp, 'bounceDroplet', p.value);
  },
  [types.UPDATE_S3_QUEUE](state, p) {
    this._vm.$log.debug('UPDATE_S3_QUEUE: ', p);
    state.s3DeleteQueue.push(p);
    if (p === 'empty') {
      state.s3DeleteQueue = [];
    }
  },
  [types.REMOVE_DROPLET](state, p) {
    p.items.splice(p.index, 1);
  },
  [types.REVERT_DROPLET](state, p) {
    state.revertedDroplet = p.initialState;
    this._vm.$set(p.items, p.index, p.initialState);
  },
  [types.SET_DROPLET_POSITION](state, p) {
    const drp = p.drp;
    let property = _.find(drp.mediaQueries, { global: true });
    property = _.find(property.properties, { property: p.pos });
    property.desktop = p.value;
  },
  [types.LOAD_SHAREABLES](state, p) {
    state.shareables = p;
  },
  [types.LOAD_SHAREABLE_DROPLET](state, p) {
    p.parent.splice(p.index, 1, p.target);
  },
  [types.CHANGE_DROPLET_CSS](state, p) {
    /* PARAMS
      drp
      property
      selector
      viewport
      val = ready to go
    */
    const drp = p.drp;
    if (!drp.mediaQueries) {
      this._vm.$set(drp, 'mediaQueries', []);
    }
    // we only use this if rule is being added for first time
    const defaults = {
      property: p.property,
      desktop: 'default',
      tablet: 'default',
      mobile: 'default',
    };
    defaults[p.viewport] = p.val;
    const selector = _.find(drp.mediaQueries, { selector: p.selector });
    // check if selector exists
    if (selector) {
      const property = _.find(selector.properties, { property: p.property });
      // if property exists, we can safely update the value
      if (property) {
        property[p.viewport] = p.val;
      } else {
        selector.properties.push(defaults);
      }
      selector.noId = p.noId;
    } else if (!p.parent) {
      // add full selector with new property if it doesn't exist
      drp.mediaQueries.push({
        selector: p.selector,
        properties: [defaults],
        noId: p.noId,
      });
    }
    if (p.parent) {
      p.parent[p.viewport] = p.val;
    }
  },
  [types.CHANGE_DROPLET_PAGE_CSS](state, p) {
    p.drp.pageCSS = p.pageCSS;
  },
  [types.SETUP_NEW_DROPLET_STYLES](state, p) {
    p.drp.pageCSS = '';
    p.drp.mediaQueries = [];
  },
  [types.SET_TOOLBAR_STATUS](state, p) {
    state.globalToolBarOpen = p;
  },
  [types.SET_GLOBAL_BUBBLE_STATUS](state, p) {
    state.globalBubbleOpen = p;
  },
  [types.SET_NEW_DROPLET_VALUES](state, p) {
    _.forEach(p.values, (item) => {
      p.vm.$set(p.drp, item.key, item.value);
    });
  },
  [types.SET_DROPLET_VAL](state, p) {
    if (typeof p.drp[p.key] === 'undefined') {
      this._vm.$set(p.drp, p.key, p.val);
    } else {
      p.drp[p.key] = p.val;
    }
  },
  [types.PUSH_DROPLET_VAL](state, p) {
    p.array.push(p.val);
  },
  [types.PREPEND_DROPLET_VAL](state, p) {
    p.array.splice(0, 0, p.val);
  },
  [types.SPLICE_DROPLET_VAL](state, p) {
    p.array.splice(p.index, 1);
  },
  [types.REPLACE_DROPLET_VAL](state, p) {
    p.array.splice(p.index, 1, p.val);
  },
  [types.SET_GLOBAL_DRAG_ITEM](state, p) {
    state.globalDragEl = p;
  },
  [types.SET_GLOBAL_OPTIONS_HOVER](state, p) {
    state.globalBubbleOptionsOpen = p;
  },
  [types.SET_GLOBAL_OPEN_MODAL](state, p) {
    state.globalOpenModal = p;
  },
  [types.SET_DRAGGING](state, p) {
    state.dragging = p;
  },
  [types.SET_VNODE_DRAG_ID](state, id) {
    state.vnodeDragId = id;
  },
  [types.SET_DROPPED_ID](state, id) {
    state.droppedId = id;
  },
};

const actions = {
  bounceDroplet: ({ commit }, p) => {
    p.value = true;
    commit(types.BOUNCE_DROPLET, p);
    return new Promise((resolve) => {
      setTimeout(() => {
        p.value = false;
        commit(types.BOUNCE_DROPLET, p);
        resolve();
      }, 250);
    });
  },
  updateS3Queue: ({ commit }, p) => {
    commit(types.UPDATE_S3_QUEUE, p);
  },
  removeDroplet: ({ commit }, payload) =>
    new Promise((resolve) => {
      commit(types.REMOVE_DROPLET, payload);
      resolve();
    }),
  revertDroplet: ({ commit, rootState, state }, payload) =>
    new Promise((resolve) => {
      const {
        activeDropletIndex,
        activeItems,
      } = rootState.StyleSidebar;
      const items = payload.items || activeItems;
      const index = typeof payload.index !== 'undefined' ? payload.index : activeDropletIndex;
      commit(types.REVERT_DROPLET, {
        ...payload,
        items,
        index,
      });
      resolve(state.revertedDroplet);
    }),
  setDropletPosition: ({ commit }, payload) => {
    commit(types.SET_DROPLET_POSITION, payload);
  },
  loadShareableDroplet({ commit }, payload) {
    commit(types.LOAD_SHAREABLE_DROPLET, payload);
  },
  // Saves all the shareables to the database
  changeDropletCss: ({ commit }, p) => {
    commit(types.CHANGE_DROPLET_CSS, p);
  },
  changeDropletPageCss: ({ commit }, p) => {
    commit(types.CHANGE_DROPLET_PAGE_CSS, p);
  },
  setupNewDropletStyles: ({ commit }, p) => {
    commit(types.SETUP_NEW_DROPLET_STYLES, p);
  },
  setToolBarStatus: ({ commit }, p) => {
    commit(types.SET_TOOLBAR_STATUS, p);
  },
  setGlobalBubbleStatus: ({ commit }, p) => {
    commit(types.SET_GLOBAL_BUBBLE_STATUS, p);
  },
  setNewDropletValues: ({ commit }, payload) => {
    commit(types.SET_NEW_DROPLET_VALUES, payload);
  },
  setDropletVal: ({ commit }, payload) => {
    commit(types.SET_DROPLET_VAL, payload);
  },
  pushDropletVal: ({ commit }, payload) => {
    commit(types.PUSH_DROPLET_VAL, payload);
  },
  prependDropletVal: ({ commit }, payload) => {
    commit(types.PREPEND_DROPLET_VAL, payload);
  },
  spliceDropletVal: ({ commit }, payload) => {
    commit(types.SPLICE_DROPLET_VAL, payload);
  },
  replaceDropletVal: ({ commit }, payload) => {
    commit(types.REPLACE_DROPLET_VAL, payload);
  },
  setGlobalDragItem: ({ commit }, payload) => {
    commit(types.SET_GLOBAL_DRAG_ITEM, payload);
  },
  setGlobalOptionsHover: ({ commit }, payload) => {
    commit(types.SET_GLOBAL_OPTIONS_HOVER, payload);
  },
  setGlobalOpenModal: ({ commit }, payload) => {
    commit(types.SET_GLOBAL_OPEN_MODAL, payload);
  },
  setDragging: ({ commit }, payload) => {
    commit(types.SET_DRAGGING, payload);
  },
  setVnodeDragId: ({ commit }, payload) => {
    commit(types.SET_VNODE_DRAG_ID, payload);
  },
  setDroppedId: ({ commit }, payload) => {
    commit(types.SET_DROPPED_ID, payload);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/_bubble-options/vuex.js